import { render, staticRenderFns } from "./ServidorDetalhe.vue?vue&type=template&id=d6105b2c&scoped=true&"
import script from "./ServidorDetalhe.vue?vue&type=script&lang=js&"
export * from "./ServidorDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./ServidorDetalhe.vue?vue&type=style&index=0&id=d6105b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6105b2c",
  null
  
)

export default component.exports